module.exports = __webpack_public_path__ + "static/media/LogoCoach.cfa26583.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/LogoCoach.png
// module id = 323
// module chunks = 0